import UnderlineHeadingCollection from '../underline-heading';
import Swiper from '../swiper-5.2.1/package/js/swiper';
// import Popup from '../popup';

document.addEventListener('DOMContentLoaded', function() {

    var swiper = new Swiper('#heroSwiper', {

    });

    // Underline headings for header
    var underlineHeadingCollection = new UnderlineHeadingCollection();
    underlineHeadingCollection.addNextListener(function(next) {
        swiper.slideTo(next);
    });
    underlineHeadingCollection.start();

    // Get popups
    // var popupsCollection = document.getElementsByClassName('c-page-popup');
    // Array.prototype.slice.call(popupsCollection).forEach(function(el) {
    //     new Popup(el);
    // });

});